 /*
  * Lightbox gallery
  */

 $('.block-gallery').lightGallery({
     selector: '.post-gallery-item',
     share: true,
     download: true,
     rotate: false,
     showThumbByDefault: true,
     loop: false,
     slideEndAnimatoin: false,
     thumbnail: true,
     allowMediaOverlap: true,
     toggleThumb: true,
     youtubePlayerParams: {
         loadYoutubeThumbnail: true,
         youtubeThumbSize: 'default',
         modestbranding: 1,
         showinfo: 0,
         rel: 0
     }
 });

 /*
  * Owl carousel
  */

 $('.owl-block').owlCarousel({
     margin: 20,
     items: 1,
     loop: true,
     autoplay: true,
     autoplayTimeout: 4500,
     nav: true,
     dots: true,
     navText: ["<i class='icon-angle-left'></i>", "<i class='icon-angle-right'></i>"],
     // navContainer: '#customNav', 
     responsive: {
        0: {
            items: 1
        },
        700: {
            items: 2,
            margin: 0,
        },
        1200: {
            items: 4,
        }
    }
 });


 $('.owl-logos').owlCarousel({
     margin: 20,
     items: 6,
     loop: true,
     autoplay: true,
     autoplayTimeout: 4500,
     nav: false,
     dots: false,
     navText: ["<i class='icon-angle-left'></i>", "<i class='icon-angle-right'></i>"],
     // navContainer: '#customNav', 
     responsive: {
         0: {
             items: 2
         }, 
         700: {
             items: 2,
             margin: 0,
         },
         1200: {
             items: 6,
         }
     }
 });

 $('.owl-cpt').not('.owl-referenzen').each(function () {
     var $carousel = $(this);

     if ($carousel.hasClass('owl-loaded')) {
         return;
     }

     var desktopItems = parseFloat($carousel.data('items-desktop')) || 1;
     var itemCount = parseInt($carousel.data('item-count'), 10) || $carousel.children().length || 1;
     var shouldLoop = itemCount > desktopItems;
     var dataNav = $carousel.data('nav');
     var dataDots = $carousel.data('dots');
     var marginDesktop = parseInt($carousel.data('margin-desktop'), 10);
     var marginMobile = parseInt($carousel.data('margin-mobile'), 10);
     var resolvedMarginDesktop = Number.isNaN(marginDesktop) ? 20 : marginDesktop;
     var resolvedMarginMobile = Number.isNaN(marginMobile) ? 0 : marginMobile;
     var showNavigation = typeof dataNav === 'boolean' ? dataNav : itemCount > 1;
     var showDots = typeof dataDots === 'boolean' ? dataDots : showNavigation;

     $carousel.owlCarousel({
         margin: resolvedMarginDesktop,
         items: desktopItems,
         loop: shouldLoop,
         autoplay: true,
         autoplayTimeout: 4500,
         nav: showNavigation,
         dots: showDots,
         navText: ["<i class='icon-angle-left'></i>", "<i class='icon-angle-right'></i>"],
         responsive: {
             0: {
                 items: 1,
                 margin: resolvedMarginMobile
             },
             700: {
                 items: 1,
                 margin: resolvedMarginDesktop
             },
             1200: {
                 items: desktopItems,
                 margin: resolvedMarginDesktop
             }
         }
     });
 });

 $('.owl-referenzen').each(function () {
     var $carousel = $(this);

     if ($carousel.hasClass('owl-loaded')) {
         return;
     }

     var desktopItems = parseFloat($carousel.data('items-desktop')) || 1;
     var itemCount = parseInt($carousel.data('item-count'), 10) || $carousel.children().length || 1;
     var shouldLoop = itemCount > desktopItems;
     var showDots = itemCount > 1;

     $carousel.owlCarousel({
         margin: 28,
         items: desktopItems,
         loop: shouldLoop,
         autoplay: true,
         autoplayTimeout: 4500,
         smartSpeed: 700,
         nav: false,
         dots: showDots,
         responsive: {
             0: {
                 items: 1,
                 margin: 16
             },
             700: {
                 items: Math.min(itemCount, 1.2),
                 margin: 20
             },
             1200: {
                 items: desktopItems,
                 margin: 28
             }
         }
     });
 });
